import type { ChangeEvent } from "react";

import type { CaptureStatus } from "../features/collection/state";

type CapturePanelProps = {
  readonly captureStatus: CaptureStatus;
  readonly isAuthenticated: boolean;
  readonly statusMessage: string | null;
  readonly onFileSelected: (file: File) => void;
  readonly onSignIn: () => void;
  readonly onSignOut: () => void;
};

const getSelectedFile = (event: ChangeEvent<HTMLInputElement>): File | null =>
  event.currentTarget.files?.item(0) ?? null;

const getButtonLabel = (status: CaptureStatus): string =>
  status === "processing"
    ? "処理中"
    : "追加";

const getStatusRole = (status: CaptureStatus): "status" | "alert" =>
  status === "failed" ? "alert" : "status";

export const CapturePanel = (props: CapturePanelProps) => {
  const isProcessing = props.captureStatus === "processing";
  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const file = getSelectedFile(event);

    file ? props.onFileSelected(file) : null;
    event.currentTarget.value = "";
  };

  return (
    <section className="capture-panel" aria-label="コレクション追加">
      <label className="capture-button">
        <span>{getButtonLabel(props.captureStatus)}</span>
        <input
          type="file"
          accept="image/*"
          disabled={isProcessing}
          onChange={handleFileChange}
        />
      </label>
      {props.isAuthenticated ? (
        <button
          className="auth-button"
          type="button"
          disabled={isProcessing}
          onClick={props.onSignOut}
        >
          ログアウト
        </button>
      ) : (
        <button
          className="auth-button"
          type="button"
          disabled={isProcessing}
          onClick={props.onSignIn}
        >
          Googleで保存
        </button>
      )}

      {props.statusMessage ? (
        <div
          className={`capture-status capture-status-${props.captureStatus}`}
          role={getStatusRole(props.captureStatus)}
          aria-live="polite"
        >
          {isProcessing ? (
            <div className="progress-track" aria-hidden="true">
              <span className="progress-indicator" />
            </div>
          ) : null}
          <p>{props.statusMessage}</p>
        </div>
      ) : null}
    </section>
  );
};
